import React from 'react';
import { formStyles } from '../../constants/SiteVariables';
import { MaskedField } from './MaskedField';

export default function Input(props) {
  return (
    <MaskedField 
      {...props} 
      name={props.id} 
      className={formStyles.error(props.error)} />
  )
}
